import { Lightbulb, Cpu, GitBranch } from "lucide-react";

const insights = [
  {
    icon: Lightbulb,
    title: "AI as a Force Multiplier",
    desc: "Why the highest-leverage engineering teams treat AI as infrastructure, not a feature.",
  },
  {
    icon: Cpu,
    title: "Caching in ASP.NET Core",
    desc: "In-memory, distributed, and response caching, what to reach for and when, with real-world trade-offs.",
  },
  {
    icon: GitBranch,
    title: "From Engineer to Architect",
    desc: "The shift in thinking that separates code-first builders from systems-first leaders.",
  },
];

export function Insights() {
  return (
    <section id="insights" className="border-y border-border bg-surface/30 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 max-w-2xl">
          <p className="font-mono text-sm text-primary">// Insights</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Field notes from the trenches.
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {insights.map((i) => (
            <div
              key={i.title}
              className="group rounded-xl border border-border bg-surface p-6 transition-smooth hover:-translate-y-1 hover:border-primary/50 hover:shadow-elevated"
            >
              <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary transition-smooth group-hover:bg-primary/20">
                <i.icon className="h-5 w-5" />
              </div>
              <h3 className="mb-2 text-lg font-semibold text-foreground">{i.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{i.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
